export default __webpack_public_path__ + "static/media/chicken_breast.88efb1b0.jpg";